import { useEffect, useMemo, useState } from 'react';
import {
  retrieveCustomColumns,
  storeCustomColumns,
  transformColumnSelections,
} from 'src/components/Table/persistCustomColumns';
import {
  IColumnSelectionState,
  ITableColumn,
} from 'src/components/Table/types';
import {
  createServiceRequestTableColumns,
  CreateTableColumnsParams,
} from '../components/helpers';

export const useCustomTableColumns = (params: CreateTableColumnsParams) => {
  const [customColumns, setCustomColumns] = useState<IColumnSelectionState[]>(
    []
  );

  const allColumns: ITableColumn[] = useMemo(
    () => createServiceRequestTableColumns(params),
    [...Object.values(params)]
  );

  const updateCustomColumns = (columns: IColumnSelectionState[]) => {
    setCustomColumns(columns);
    storeCustomColumns(columns, 'service-requests');
  };

  useEffect(() => {
    const customColumns: IColumnSelectionState[] = retrieveCustomColumns(
      allColumns,
      'service-requests'
    );

    setCustomColumns(customColumns);
  }, []);

  const transformedColumns: ITableColumn[] = useMemo(() => {
    return transformColumnSelections(allColumns, customColumns);
  }, [customColumns, allColumns]);

  return {
    customColumns,
    updateCustomColumns,
    transformedColumns,
    allColumns,
  };
};
